export default "__VITE_ASSET__BvwIWxza__"